import angular from 'angular';


const duration = angular.module('ttb.directives.duration', [])
    .directive('duration', () => {
        return {
            require: 'ngModel',
            link: (scope, element, attrs, ctrl) => {

                ctrl.$validators.duration = function (modelValue, viewValue) {

                    if (ctrl.$isEmpty(modelValue)) {
                        // consider empty models to be valid
                        return true;
                    }
                    return !viewValue.invalid;
                };
            }
        };
    })
    .name;

export default duration


// WEBPACK FOOTER //
// ../directives/duration.js